import {CircleAlert} from "lucide-react";
import {useTranslationWithKeys} from "../../hooks/useTranslationWithKeys";
import {NotificationBanner} from "./banners/NotificationBanner";

interface ErrorNotificationProps {
    errorCode: string;
    onClose: () => void;
}

export function ErrorNotification({errorCode, onClose}: ErrorNotificationProps) {
    const {t} = useTranslationWithKeys();

    return (
        <NotificationBanner
            variant="destructive"
            icon={<CircleAlert/>}
            message={t(`error.${errorCode}`, {defaultValue: t('error.UnknownError')})}
            onClose={onClose}
        />
    );
}
